import './CSS/ContactMeTitleStyle.css';
function ContactMeTitle(props) {
    return (
        <h1 id="getintouchcolor">Get in touch</h1>          
    );
  }
  
  export default ContactMeTitle;
  